import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Product item type
export interface ProductItems {
  id: string;
  [key: string]: any;
}

// API response shape
interface PromoListResponse {
  productManifests: ProductItems[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface PromoState {
  data: PromoListResponse | null;
  loading: boolean;
  error: string | null;
}

// Update payload
export interface PromoUpdatePayload {
  id: string;
  [key: string]: any;
}

const initialState: PromoState = {
  data: null,
  loading: false,
  error: null,
};

const productManifestSlice = createSlice({
  name: "productManifest",
  initialState,
  reducers: {
    setProductManifestList(state, action: PayloadAction<PromoListResponse>) {  
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },

    addProductManifest(state, action: PayloadAction<ProductItems>) {
      const newPromo = action.payload;

      if (state.data) {
        state?.data?.productManifests?.unshift(newPromo);
        state.data.total += 1;

        // keep pagination consistent
        if (state.data.productManifests.length > 10) {
          state?.data?.productManifests?.pop();
        }
      } else {
        state.data = {
          productManifests: [newPromo],
          total: 1,
          page: 1,
          totalPages: 1,
        };
      }
    },

    // promoUpdate(state, action: PayloadAction<PromoUpdatePayload>) {
    //   const { id, ...updates } = action.payload;
    //   if (!state.data?.productItems) return;

    //   const promo = state.data.productItems.find((p) => p.id === id);
    //   if (promo) {
    //     Object.assign(promo, updates);
    //   }
    // },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setProductManifestList,
  addProductManifest,
  // promoUpdate,
  setLoading,
  setError,
} = productManifestSlice.actions;

export default productManifestSlice.reducer;
